<template>
  <div class="bgImage">
    <nav class="navbar navbar-light bg-light-translucent justify-content-between">
      <a class="navbar-brand" href="#">
        <img src="assets/Transport.svg" height="30" alt="">
      </a>
      <form class="form-inline my-2 my-lg-0">
        <div class="container">
          <img src="assets/Slogan.svg"  class="d-inline-block align-top" height="25">
          <img src="assets/Home Button.svg"  class="d-inline-block align-top" height="25" v-on:click="logout">
        </div>
      </form>
    </nav>
    <div class="col-1 list-left">
      <ul class="list-group list-group-flush mt-2">
        <li class="list-group-item list-item-bg rounded">
          <img src="assets/architectus-logo.png"  class="img-fluid" height="20">
        </li>
        <li class="list-group-item list-item-bg rounded" >
          <img src="assets/Arcadis.svg"  class="img-fluid" height="25">
        </li>
        <li class="list-group-item list-item-bg rounded">
          <img src="assets/TT_logo2.png"  class="img-fluid"  height="20" >
        </li>
        <li class="list-group-item list-item-bg rounded">
          <img src="assets/Indec Logo2.png"  class="img-fluid" height="35">
        </li>
      </ul>
    </div>
    <div class="col-1 list-right ">
      <ul class="list-group list-group-flush mt-2">
        <li class="list-group-item list-item-bg rounded tfnsw">
          <a :href="links.tfnswProjectPage" target="_blank">
            <img src="assets/TfNSW Logo.png"  class="img-fluid" height="25">
          </a>
        </li>
        <li class="in-eight list-group-item list-item-bg rounded ">
          <a :href="links.inEightWebsite" target="_blank">
            <img src="assets/inEight Logo.png"  class="img-fluid" height="25">
          </a>
        </li>
        <li class=" list-group-item list-item-bg rounded ">
          <a :href="links.projectWiseWebsite" target="_blank">
            <img src="assets/ProjectWise.png"  class="img-fluid" height="25">
          </a>
        </li>
      </ul>
    </div>
    <div v-if="accessToken">
      <CircularContainer/>
    </div>
    <div v-else>
      <br><br><br>
      <LoginContainer/>
    </div>



  </div>
</template>

<script>
import CircularContainer from './CircularContainer.vue'
import LoginContainer from './LoginContainer.vue'

export default {
  name: 'Landing',
  components: {
    CircularContainer,
    LoginContainer
  },
  data() {
    return {
      links: {
      //   communityPortal: "http://under-construction.geodemosolutions.com/",
      //   projectInduction: "http://under-construction.geodemosolutions.com/",
      //   projectDocuments: "http://under-construction.geodemosolutions.com/",
      //   peopleDetails: "http://under-construction.geodemosolutions.com/",
      //   actionsList: "http://under-construction.geodemosolutions.com/",
      //   // designPortal: "https://transport-central-3d-commenting.geodemosolutions.com/",
      //   designPortal: "https://arcadis.maps.arcgis.com/apps/webappviewer3d/index.html?id=609d3573e26c4a118613702e7e2f0579",
      //   stakeholderPortal: "http://under-construction.geodemosolutions.com/",
      //   lessonLearnedLibrary: "http://under-construction.geodemosolutions.com/",
        tfnswProjectPage: "https://www.transport.nsw.gov.au/projects",
        inEightWebsite: "https://ineight.com/solutions/collaborative-document-management/",
        projectWiseWebsite: "https://www.bentley.com/en/products/brands/projectwise"
      },
      accessToken: ""
    }
  },
  computed: {
    accessTokenTemp () {
      return this.$store.state.user.accessToken
    }
  },
  created() {
    if (sessionStorage.hasOwnProperty("accessToken")) {
      this.accessToken = sessionStorage.getItem("accessToken")
      this.$store.commit("user/storeToken", this.accessToken)
    }
  },
  watch: {
    accessTokenTemp(newVal, oldVal) {
      this.accessToken = newVal;
      console.log("entered WATCH on Landing");
    }
  },
  methods: {
    logout: function() {
      sessionStorage.setItem("accessToken","")
      this.$store.commit("user/storeToken", "")
    }
  }
}
</script>

<style>
  .bg-light-translucent {
    background-color: rgba(248, 249, 250, 0.15);
    margin:0;
    padding:0;
  }
  .navbar-brand {
    width: 35vw;
  }
  .noImage {
    background-image: none!important;
  }
</style>
